import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/global.scss'
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store'
import { GoogleOAuthProvider } from "@react-oauth/google"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider clientId="308813414385-b4pmdmre5n4doloi677kncu2edvf64av.apps.googleusercontent.com">
        <App />
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>
);

